export default __webpack_public_path__ + "static/media/save.06ac6e56.svg";